import { Component, Input } from '@angular/core';
import { Reservation } from '../../interfaces/reservation';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalendarAlt, faQrcode, faCreditCardAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reservation-card',
  standalone: true,
  imports: [CommonModule, RouterModule, FontAwesomeModule, ButtonComponent, TranslateModule],
  templateUrl: './reservation-card.component.html',
  styleUrl: './reservation-card.component.scss'
})
export class ReservationCardComponent {
  @Input() reservation!: Reservation
  @Input() isPast: boolean = false
  @Input() goToReservation!: Function;
  @Input() addDays!: Function;
  faCalendarAlt = faCalendarAlt
  faQrcode = faQrcode
  faCreditCardAlt = faCreditCardAlt
  faArrowRight = faArrowRight
  isExpanded: boolean = false;


}
